import React, { useRef, useState, useEffect } from "react";
import Highcharts, { chart } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { LOGO, SOCIAL_SOURCES } from "../../../../constants/app-constant";
import { getInlineFilterText, getTimelineText, getTimelineTextPosition } from "../../../../utility/common-methods";

const formatData = (data) => {
  if (!data && !data.length) return;
  return data.map((x) => ({
    data: [
      Number(x.count),
      Number(x.original),
      Number(x.comment_count),
      Number(x.share_count),
      Number(x.like_count),
    ],
  }));
};
export function PieChartHC({
  graphApiResponse: { hcPieChartData = [{}] },
  chartTitle,
  onEntityClick,
  entityList,
  showPercentage,
  isEmbededWidget,
  identifier,
  setGraphRef,
  setGraphRefList,
  mediaType,
  data,
  reportType,
  twitterFeeds,
  insightFeeds = 0,
  to_date,
  from_date,
  dateHash,
  widget,
  selectedInlineJournalist,
  selectedInlinePlatform,
  selectedInlinePublication,
  selectedInlineSentiment,
  isBlogAndForum,
  isSocial,
  selectedInlineWCType
}) {
  const [chartData, setChartData] = useState({});
  const ref = useRef();
  const twitterPieData = [
    {
      name: "Retweets",
      y: (twitterFeeds?formatData(data)[0].data[3]:(0)),
      backgroundColor: "#FCC023",
    },
    {
      name: "Original Tweets",
      y: (twitterFeeds?formatData(data)[0].data[1]:(0)),
      backgroundColor: "#D63548",
    },
    {
      name: "Replies",
      y: (twitterFeeds?formatData(data)[0].data[2]:(0)),
      backgroundColor: "#0979E4",
    },
    {
      name: "Quoted",
      y: (twitterFeeds?formatData(data)[0].data[3]:(0)),
      backgroundColor: "#AF8BAF",
    },
  ];
  let insightPieData = []
  if(insightFeeds != undefined && insightFeeds === SOCIAL_SOURCES.INSTAGRAM){
    insightPieData = [
      {
        name: "Comment",
        y: ((insightFeeds != undefined && insightFeeds !== 0?formatData(data)[0].data[2]:0)),
        backgroundColor: "#FCC023",
      },
      {
        name: "Likes",
        y: ((insightFeeds != undefined && insightFeeds !== 0?formatData(data)[0].data[4]:0)),
        backgroundColor: "#0979E4",
      },
    ];
  }
  else{
    insightPieData = [
      {
        name: "Comment",
        y: ((insightFeeds != undefined && insightFeeds !== 0?formatData(data)[0].data[2]:0)),
        backgroundColor: "#FCC023",
      },
      {
        name: "Share",
        y: ((insightFeeds != undefined && insightFeeds !== 0?formatData(data)[0].data[3]:0)),
        backgroundColor: "#D63548",
      },
      {
        name: "Likes",
        y: ((insightFeeds != undefined && insightFeeds !== 0?formatData(data)[0].data[4]:0)),
        backgroundColor: "#0979E4",
      },
    ];
  }
  useEffect(() => {
    setGraphRef(ref);
  }, []);
  useEffect(() => {
    if (data) {
      twitterFeeds && redrawChart();
      (insightFeeds !== undefined && insightFeeds !== 0) && redrawChart();
    }
  }, [data]);

  useEffect(() => {
    if (!twitterFeeds && (insightFeeds == undefined || insightFeeds == 0)) {
      redrawChart();
    }
  }, [hcPieChartData, showPercentage]);
  if (!hcPieChartData) {
    return;
  }
  const customLabel = () => {
    if (showPercentage) {
      if (isEmbededWidget) {
        return "<b>{point.name}-{point.percentage:.1f} %";
      }
      return "{point.percentage:.1f} %";
    } else {
      if (isEmbededWidget) {
        return "<b>{point.name}</b>-{point.y}";
      }
      return "{point.y}";
    }
  };
  const redrawChart = () => {
    const options = {
      chart: {
        type: "pie",
      },
      legend: {
        enabled: true,
        margin: 0,
        maxHeight: 65,
      },
      title: {
        text: chartTitle,
        margin: 10,
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          color: "#666",
        },
      },
      exporting: {
        sourceWidth: 1200,
        chartOptions: {
          legend: {
            enabled: true,
            verticalAlign: "top",
            maxHeight: 1000,
            margin: 25,
            y: 70,
          },
          chart: {
            events: {
              load: function () {
                var renderer = this.renderer;
                renderer
                  .text(
                    `${getTimelineText(to_date,from_date,dateHash)}`,
                    getTimelineTextPosition(getTimelineText(to_date,from_date,dateHash)),
                    80
                  )
                  .add();
                renderer
                  .text(
                    `${getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)} `,
                    getTimelineTextPosition(getInlineFilterText(widget,selectedInlineJournalist,selectedInlinePlatform,selectedInlinePublication,selectedInlineSentiment,isBlogAndForum,isSocial,selectedInlineWCType)),
                    95
                  )
                  .add();
                renderer
                  .image(LOGO.biuLogoBase, 725, 10, 50, 50)
                  .attr({
                    align: "center",
                  })
                  .add();
              },
            },
          },
        },
      },
      series: [
        {
          name: "Count",
          data: twitterFeeds? twitterPieData : (insightFeeds !== undefined && insightFeeds !== 0?insightPieData:hcPieChartData),
        },
      ],
      plotOptions: {
        pie: {
          allowPointSelect: true,
          shadow: false,
          cursor: "pointer",
          showInLegend: !isEmbededWidget,
          margin: [0, 0, 0, 0],
        },
        series: {
          cursor: "pointer",
          events: {
            click: (e) => handlePieClick(e),
          },
          dataLabels: {
            distance: isEmbededWidget ? 20 : -15,
            format: customLabel(),
          },
        },
      },
    };
    setChartData(options);
    if (setGraphRefList) {
      setGraphRefList(identifier + mediaType, ref, options);
    }
  };

  const handlePieClick = (e) => {
    try {
      const label = e.point.options.name;
      let routeParams = {
        entityId: null,
        vertical: null,
        date: null,
        labels: label,
      };
      let entity =
        entityList &&
        entityList.filter(
          (elm) => label == elm.entity_display_name?.trim() || label == elm.name
        )[0];
      routeParams.entityId = entity && entity.id.toString();
      onEntityClick(e, routeParams);
    } catch (e) {
      onEntityClick(e, {});
    }
  };

  return (
    <div key={Math.random()} id={`hc-${identifier}`}>
      <HighchartsReact highcharts={Highcharts} options={chartData} ref={ref} />
    </div>
  );
}

PieChartHC.defaultProps = {
  graphApiResponse: {},
  chartTitle: "",
  onEntityClick: () => {},
  entityList: [],
  showPercentage: false,
  selectedDataType: "",
  identifier: "",
  setGraphRef: () => {},
  setGraphRefList: () => {},
};
